import React from "react";

export default function ScreenOverlay({ hideOverlay, overlayLock, content }) {
  return (
    <div
      onClick={() => !overlayLock && hideOverlay}
      className="fixed z-50 w-full h-full bg-black bg-opacity-[50%] flex justify-center items-center"
    >
      {content}
    </div>
  );
}
